// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formik-color-field {
  background: #fff;
  border: 1px solid #d6d6d6;
  border-radius: 4px;
  height: 34px;
  padding: 2.5px;
}

.formik-color-field__color {
  flex: 1;
  width: 35px;
  height: 18px;
  margin-right: 15px;
  display: inline-block;
}

.formik-color-field__dialog {
  border-radius: var(--base-sizes-1);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--semantic-colors-surface-default) / var(--tw-bg-opacity));
  z-index: 1;
  border: 1px solid #d6d6d6;
  position: absolute;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/FormikColorField/FormikColorField.css","webpack://./services/frontend/app/components/FormikColorField/FormikColorField.css"],"names":[],"mappings":"AADA;ECEE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,oFAAoF;EACpF,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".formik-color-field {\n  background: #fff;\n  border: 1px solid #d6d6d6;\n  border-radius: 4px;\n  padding: 2.5px;\n  height: 34px;\n}\n\n.formik-color-field__color {\n  display: inline-block;\n  flex: 1;\n  height: 18px;\n  width: 35px;\n  margin-right: 15px;\n}\n\n.formik-color-field__dialog {\n  border-radius: var(--base-sizes-1);\n  --tw-bg-opacity: 1;\n  background-color: rgb(var(--semantic-colors-surface-default) / var(--tw-bg-opacity));\n\n  border: 1px solid #d6d6d6;\n  position: absolute;\n  z-index: 1;\n}\n",".formik-color-field {\n  background: #fff;\n  border: 1px solid #d6d6d6;\n  border-radius: 4px;\n  height: 34px;\n  padding: 2.5px;\n}\n\n.formik-color-field__color {\n  flex: 1;\n  width: 35px;\n  height: 18px;\n  margin-right: 15px;\n  display: inline-block;\n}\n\n.formik-color-field__dialog {\n  border-radius: var(--base-sizes-1);\n  --tw-bg-opacity: 1;\n  background-color: rgb(var(--semantic-colors-surface-default) / var(--tw-bg-opacity));\n  z-index: 1;\n  border: 1px solid #d6d6d6;\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
